import { Record } from 'immutable';
export default class HubUser extends Record({
  id: undefined,
  firstName: undefined,
  lastName: undefined,
  email: undefined,
  avatarUri: undefined
}) {}